module.exports = __webpack_public_path__ + "static/media/folder-tree.a62b9080.svg";